import { createAction, props } from '@ngrx/store';
import { HttpErrorResponse } from '@angular/common/http';

import {
  IChildUserRoleDetails,
  IGetEachVcodeDetailRes,
  ISecurityGroupSet,
  ISecuritySetModifier,
  IVCodeGeneralLevel,
  IVcodeIndividualData,
  IassignRoleLandingPage,
  IUserPreferencesResponse,
  ISubmissionBody,
  TAddEditUserScreenType,
  IAddUserSearchCriteria,
  IOAAUser,
  IExistingUsersSearchCriteria,
  IEditUserSearchResult,
  IEditUserRemoveRequestData,
  IEditUserActiveResponse,
  IRoleAndFeatures,
  TGroupRolesApisDone,
  IPendingUser
} from './security-management.model';
import { FormGroup } from '@angular/forms';

export const getSecuritySets = createAction('[Security Management] Get Security Sets');

export const resetSecurityManagement = createAction('[Security Management] Reset Assign User Role State');

export const getSecuritySetsSuccess = createAction(
  '[Security Management] Get Security Sets SUCCESS',
  props<{ securitySets: ISecurityGroupSet[] }>()
);

export const getSecuritySetsFailure = createAction(
  '[Security Management] Get Security Sets FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const clearSecuritySets = createAction('[Security Management] Clear Security Sets');

export const sortUserSearch = createAction(
  '[Security Management] Sort',
  props<{ col: keyof any; lastSortedCol: keyof any }>()
);

export const setCurrentSecuritySet = createAction(
  '[Security Management] Set Current Security Set',
  props<{ securitySet: ISecurityGroupSet }>()
);

// assign user role use:
export const getChildUserDetails = createAction(
  '[Security Management] Get Child User Details',
  props<{ securityGroupId: string; childUserName?: string; invitationId?: string }>()
);

export const getChildUserDetailsSuccess = createAction(
  '[Security Management] Get Child User Details SUCCESS',
  props<{ childUserInfo: IChildUserRoleDetails, invitationId?: string }>()
);

export const getChildUserDetailsFailure = createAction(
  '[Security Management] Get Child User Details FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const setDemographicInfo = createAction(
  '[Security Management] Set Demographic Info',
  props<{ demo: IUserPreferencesResponse }>()
);

export const setSellectedCountInChildUserDetails = createAction(
  '[Security Management] Set Sellected Count In ChildUser',
  props<{ childUserWithCount: IChildUserRoleDetails }>()
);

export const setAssignRoleModifierSection = createAction(
  '[Security Management] Set Assign User Role Page Modifier Section',
  props<{ securityModifier: ISecuritySetModifier }>()
);

export const setRoleLandingState = createAction(
  '[Security Management] Set RoleLanding Page State',
  props<{ roleLandingStore: IassignRoleLandingPage[] }>()
);

export const setRoleTable = createAction(
  '[Security Management] Set Role Table',
  props<{ roleAndFeatures: IRoleAndFeatures }>()
);

export const resetAssignUserRoleState = createAction('[Security Management] Reset Assign User Role State');

// get Vcode level data in data view page:
export const getVcodeGeneralData = createAction(
  '[Security Management] Get VCODE Summary Data',
  props<{ securityGroupId: string; childUserName?: string; roleType: string, invitationId?: string }>()
);

export const getVcodeGeneralDataSuccess = createAction(
  '[Security Management] Get VCODE Summary Data SUCCESS',
  props<{ data: IVCodeGeneralLevel }>()
);

export const getVcodeGeneralDataFailure = createAction(
  '[Security Management] Get VCODE Summary Data FAILURE',
  props<{ error: HttpErrorResponse }>()
);

// get eachVcode details in data view page:
export const getEachVcodeDetailsData = createAction(
  '[Security Management] Get Each Vcode Detail Data',
  props<{ vCode: string }>()
);

export const getEachVcodeDetailsDataSuccess = createAction(
  '[Security Management] Get Each Vcode Detail Data SUCCESS',
  props<{ vCode: string; data: IGetEachVcodeDetailRes }>()
);

export const getEachVcodeDetailsDataFailure = createAction(
  '[Security Management] Get Each Vcode Detail Data FAILURE',
  props<{ vCode: string; error: HttpErrorResponse }>()
);

export const setPagePosition = createAction(
  '[Security Management] Set Page Position',
  props<{ pagePosition: { position: number } }>()
);

export const selectedVcodesOfEachRole = createAction(
  '[Security Management] Select Providers By Vcode',
  props<{ roleType: string; vcodes: IVcodeIndividualData[] }>()
);

export const clearSelectedVcodes = createAction(
  '[Security Management] Clear Selected Providers',
  props<{ roleType: string }>()
);

export const saveUser = createAction('[Security Management] Save User', props<{ submitObj?: ISubmissionBody }>());

export const saveUserSuccess = createAction('[Security Management] Save User SUCCESS', props<{ response: any }>());

export const saveUserFailure = createAction('[Security Management] Save User FAILURE', props<{ error: any }>());

export const resetSubmissionState = createAction('[Security Management] Reset Submission State');

export const setScreenType = createAction(
  '[Security Management] Set Screen Type',
  props<{ screenType: TAddEditUserScreenType }>()
);

// // add User Search
export const userSearch = createAction(
  '[Add User] Search Users',
  props<{ addUserSearchCriteria: IAddUserSearchCriteria }>()
);

export const userSearchSuccess = createAction(
  '[Add User] Search Users SUCCESS',
  props<{ addUserSearchResults: IOAAUser[] }>()
);

export const userSearchFailure = createAction('[Add User] Search Users FAILURE', props<{ error: HttpErrorResponse }>());

export const resetAddUserSearch = createAction('[Add User] Reset Add User Search');
export const resetuserSearchState = createAction('[Add User] Reset Add User Search state',
  props<{ pageSize }>());

export const userSearchState = createAction(
  '[Add User] Search Users state',
  props<{ pageNumber, sort, addUserPagePosition, pageSize }>()
);

// // edit User Search
export const searchExistingUsers = createAction(
  '[Edit User] Search Existing Users',
  props<{ editUserSearchCriteria: IExistingUsersSearchCriteria }>()
);

export const searchExistingUsersSuccess = createAction(
  '[Edit User] Search Existing Users SUCCESS',
  props<{ editUserSearchResults: IEditUserSearchResult[] }>()
);

export const searchExistingUsersFailure = createAction(
  '[Edit User] Search Existing Users FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const resetEditUserSearch = createAction('[Edit User] Reset Edit User Search');

// // Edit User demographic
export const setEditExistingUserDemographic = createAction(
  '[Edit User] Set Existing User Info',
  props<{ demographic: IUserPreferencesResponse }>()
);

export const getEditChildUserDemographic = createAction(
  '[Edit User] Get Child User Demographic',
  props<{ childUserName: string }>()
);

export const getEditChildUserDemographicSuccess = createAction(
  '[Edit User] Get Child User Demographic SUCCESS',
  props<{ userPreferences: IUserPreferencesResponse }>()
);

export const getEditChildUserDemographicFailure = createAction(
  '[Edit User] Get Child User Demographic FAILURE',
  props<{ error: HttpErrorResponse }>()
);

export const setEditChildUserInfo = createAction(
  '[Edit User] Set Security Sets',
  props<{ childUserInfo: IEditUserSearchResult }>()
);

// editUser remove action
export const removeEditUser = createAction(
  '[Edit User] Remove Edit User',
  props<{ editUserRemoveRequest: IEditUserRemoveRequestData }>()
);

export const removeEditUserSuccess = createAction(
  '[Edit User] Remove Edit User SUCCESS',
  props<{ editUserResponse: any }>()
);

export const removeEditUserFailure = createAction(
  '[Edit User] Remove Edit User FAILURE',
  props<{ error: HttpErrorResponse }>()
);

// edit user
export const activeEditUser = createAction('[Edit User] Active Edit User', props<{ activeEditUserName: string }>());

export const activeEditUserSuccess = createAction(
  '[Edit User] Active Edit User SUCCESS',
  props<{ activeEditUserResponse: IEditUserActiveResponse[] }>()
);

export const activeEditUserFailure = createAction(
  '[Edit User] Active Edit User FAILURE',
  props<{ error: HttpErrorResponse }>()
);

// add/edit user
// // store the role name that assign[role name] API is called
export const setListenAssignApiCall = createAction(
  '[Security Management] set Listen Assign Roles Api Call',
  props<{ roleName: string }>()
);

export const clearListenApiCall = createAction('[Security Management] clear Listen Assign Roles Api Call');

// // record the status of group of Roles GET api calls are done/not to control btn disabled or loading animation
export const groupRolesApiCallsdDone = createAction(
  '[Security Management] group of Roles GET api calls are done',
  props<{ requestsAreCalled: TGroupRolesApisDone }>()
);

// pending User:
export const getPendingUsers = createAction(
  '[Security Management] Get Pending User Details',
);

export const getPendingUsersSuccess = createAction(
  '[Security Management] Get Pending User Details SUCCESS',
  props<{ pendingUsers: IPendingUser[] }>()
);

export const getPendingUsersFailure = createAction(
  '[Security Management] Get Pending User Details FAILURE',
  props<{ error: HttpErrorResponse }>()
);
